import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import API_BASE_URL from '../../config';
import Swal from 'sweetalert2';
import { Card, CardContent, Typography, LinearProgress, TextField, Button, Box, Divider } from '@mui/material';
import KeyboardReturnRoundedIcon from '@mui/icons-material/KeyboardReturnRounded';
import { IconButton } from '@mui/material';
import './CreateOrganization.css';

const CreateOrganization = () => {
  const [isEnabled, setIsEnabled] = useState(null);
  const [orgData, setOrgData] = useState(null);
  const [orgName, setOrgName] = useState('');
  const [orgEmail, setOrgEmail] = useState('');
  const [orgNumber, setOrgNumber] = useState('');
  const navigate = useNavigate();
  // todo: if only 1 org, disable delete
  useEffect(() => {
    const fetchAdminStatus = async () => {
      const token = localStorage.getItem('token');

      if (!token) {
        navigate('/unauthorized');
        return;
      }

      try {
        const response = await fetch(`${API_BASE_URL}/users/admin`, {
          method: 'GET',
          headers: {
            'Authorization': `Bearer ${token}`,
          },
        });

        if (!response.ok) {
          throw new Error('Failed to fetch admin status');
        }

        const data = await response.json();
        setIsEnabled(data.isEnabled);

        if (data.isEnabled !== 1) {
          navigate('/unauthorized');
        } else {
          fetchOrgInfo(token);
        }
      } catch (error) {
        console.error('Error fetching admin status:', error);
        navigate('/unauthorized');
      }
    };

    const fetchOrgInfo = async (token) => {
      try {
        const response = await fetch(`${API_BASE_URL}/users/admin/org-info`, {
          method: 'GET',
          headers: {
            'Authorization': `Bearer ${token}`,
          },
        });

        if (!response.ok) {
          throw new Error('Failed to fetch organization info');
        }

        const data = await response.json();
        setOrgData(data);
      } catch (error) {
        console.error('Error fetching organization info:', error);
      }
    };

    fetchAdminStatus();
  }, [navigate]);

  const calculateUsagePercentage = () => {
    if (orgData) {
      return Math.floor((orgData.org_count / orgData.max_org) * 100);
    }
    return 0;
  };
  

  const isCreateButtonEnabled = orgData && orgData.org_count < orgData.max_org;

  const handleCreateOrganization = async () => {
    if (!orgName || !orgEmail || !orgNumber) {
      Swal.fire({
        title: 'Error!',
        text: 'Please fill out all fields.',
        icon: 'error',
        confirmButtonText: 'OK',
      });
    } else {
      try {
        const token = localStorage.getItem('token');
  
        const response = await fetch(`${API_BASE_URL}/org/organization-settings/create-org`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}`,
          },
          body: JSON.stringify({
            orgName: orgName,
            orgEmail: orgEmail,
            orgNumber: orgNumber,
          }),
        });
  
        if (response.status === 201) {
          const data = await response.json();
          console.log('Organization created:', data);
  
          Swal.fire({
            title: 'Success!',
            text: 'Organization created successfully!',
            icon: 'success',
            confirmButtonText: 'OK',
          }).then(() => {
            navigate('/organization/settings'); 
          });
        } else {
          throw new Error('Failed to create organization');
        }
      } catch (error) {
        console.error('Error creating organization:', error);
        Swal.fire({
          title: 'Error!',
          text: 'Failed to create organization.',
          icon: 'error',
          confirmButtonText: 'OK',
        });
      }
    }
  };
  

                
  return (
    <div className="org-card-grid">
      <Card sx={{ width: '100%', margin: 'auto', mt: 0, background: 'none', boxShadow: 'none' }}>
      <Box sx={{ display: 'flex', alignItems: 'center', p: 2 }}>
        <IconButton onClick={() => navigate('/organization/settings')} sx={{ mr: 2 }}>
        <KeyboardReturnRoundedIcon />
        </IconButton>
        <Typography variant="h5" sx={{ flexGrow: 1 }}>
          Create Organization
        </Typography>
      </Box>
      <Divider />   
      <CardContent>
        <CardContent>
          {orgData != null && (
            <Box sx={{ mb: 2 }}>
              <Typography variant="body2" color="text.secondary">
                Current Plan Usage: {orgData.org_count} / {orgData.max_org} Organization(s)
              </Typography>
              <LinearProgress variant="determinate" value={calculateUsagePercentage()} sx={{ height: 8, borderRadius: 4, mt: 1 }} />
            </Box>
        )}
        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
          <TextField
            label="Organization Name"
            variant="outlined"
            value={orgName}
            multiline
            rows={1}
            onChange={(e) => setOrgName(e.target.value)}
            disabled={!isCreateButtonEnabled}
            inputProps={{ maxLength: 100 }}
            fullWidth
          />
          <TextField
            label="Organization Email"
            variant="outlined"
            type="email"
            value={orgEmail}
            multiline
            rows={1}
            onChange={(e) => setOrgEmail(e.target.value)}
            disabled={!isCreateButtonEnabled}
            inputProps={{ maxLength: 255 }}
            fullWidth
          />
          <TextField
            label="Organization Phone Number"
            variant="outlined"
            value={orgNumber}
            multiline
            rows={1}
            onChange={(e) => setOrgNumber(e.target.value)}
            disabled={!isCreateButtonEnabled}
            inputProps={{ maxLength: 20 }}
            fullWidth
          />
        </Box>
        <Box sx={{ mt: 3, display: 'flex', justifyContent: 'flex-end' }}>
          <Button
            variant="contained"
            color="primary"
            disabled={!isCreateButtonEnabled}
            onClick={handleCreateOrganization}
            size="large"
          >
            Create Organization
          </Button>
        </Box>
      </CardContent>
      </CardContent>
    </Card>
  </div>
);
};

export default CreateOrganization;
